import type { RouteObject } from "react-router-dom";
import { RootRedirectPage } from "./pages/RootRedirectPage";

export const rootRoutes: RouteObject[] = [
  {
    index: true,
    element: <RootRedirectPage />,
  },
];
